import ComplianceService from '@/services/requests/complianceService'
import Store from '@/store/computed/storeHelpers'
export default {
  methods: {
    getCompliances() {
      this.loadingCompliances = true;
      ComplianceService.getAllCompliances().then(result => {
        //console.log(result);
        this.loadingCompliances = false;
        this.compliance = result.data.result;
        console.log(this.compliance)
      }).catch(err => {
        console.log(err);
        this.loadingCompliances = false;
        this.snackError();
      })
    }
  },
  computed: {
    loadingCompliances: Store.getSet({ store: 'compliance', prop: 'loadingCompliances' }),
    compliance: Store.getSet({ store: 'compliance', prop: 'compliance' })
  },
  mounted() {
    //console.log('MOUNTED HOOK:', this.compliance)
    // if (!this.compliance.length) {
    this.getCompliances()
    // }
  },
  beforeDestroy() {
    if (!this.keepMasterFiles) this.compliance = [];
  },
}